var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H36V30H0V6Z",
    fill: "#C60B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H36V24H0V12Z",
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEs);
export default __webpack_public_path__ + "static/media/flag-es.fa75b2928b925399b9c2c84ae4abd248.svg";
export { ForwardRef as ReactComponent };